import { type ReactElement, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../auth/AuthContext";

// The authenticated console chrome shared by the participant, collaborator, and
// admin pages: sticky app bar (brand + signed-in email + sign-out) over one
// centered column. All three consoles use the same wide column (app.css
// .app-main) — the page supplies only its brand label and content.
export function AppShell({
  brand,
  children,
}: {
  brand: string;
  children: ReactNode;
}): ReactElement {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function onLogout(): Promise<void> {
    await logout();
    navigate("/", { replace: true });
  }

  return (
    <div className="app-shell">
      <header className="app-bar">
        <span className="nav-brand-name">{brand}</span>
        <div className="app-bar-right">
          <span className="muted">{user?.email ?? user?.study_id}</span>
          <button className="btn-ghost btn-sm" onClick={onLogout}>
            Sign out
          </button>
        </div>
      </header>
      <main className="app-main">{children}</main>
    </div>
  );
}
